import { MonthDivider, MonthDividerResponse } from "burde";
import * as api from "util/api";

export const getStmMonthDividers = async (
    culture: string,
    calendarSize: string,
) => {
    try {
        const { success, data } = await api.json.get(
            `api/ui/GetMonthDividers`,
            {
                culture,
                calendarSize,
            },
        );

        if (!success) {
            return;
        }

        return data as MonthDividerResponse;
    } catch (error) {
        return;
    }
};

export const getStmMonthDividerById = async (
    culture: string,
    calendarSize: string,
    id: number,
) => {
    const { success, data } = await api.json.get(`api/ui/GetMonthDividerById`, {
        id,
        culture,
        calendarSize,
    });

    if (!success) return null;

    return data as MonthDivider;
};
